import { useState } from 'react';
import Reveal from '../components/Reveal';
import { SERVICES } from '../data';

export default function Services({ openForm }) {
  const [activeTab, setActiveTab] = useState('developers');

  return (
    <div style={{ paddingTop: 90 }}>
      <section className="section">
        <div className="container">
          <Reveal>
            <span className="tag">What We Do</span>
            <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(32px,5vw,62px)', fontWeight: 900, marginBottom: 20 }}>
              Specialized marketing<br />for real estate.
            </h1>
            <p style={{ color: 'var(--mut)', fontSize: 18, maxWidth: 560, lineHeight: 1.8, marginBottom: 52 }}>
              Four focused services. One integrated system. Built exclusively for Indian real estate developers and channel partners.
            </p>
          </Reveal>

          {/* ── Who are you? Tab ── */}
          <Reveal>
            <div style={{ display: 'flex', gap: 12, marginBottom: 64, flexWrap: 'wrap' }}>
              <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--mut)', display: 'flex', alignItems: 'center', marginRight: 8 }}>
                I am a:
              </div>
              {[
                { key: 'developers',      label: '🏗️ Developer / Builder' },
                { key: 'channelPartners', label: '🤝 Channel Partner / Realtor' },
              ].map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    padding: '11px 22px',
                    borderRadius: 10,
                    border: `2px solid ${activeTab === tab.key ? 'var(--acc)' : 'var(--bdr)'}`,
                    background: activeTab === tab.key ? 'rgba(0,229,204,0.1)' : 'transparent',
                    color: activeTab === tab.key ? 'var(--acc)' : 'var(--mut)',
                    fontFamily: 'var(--fB)', fontWeight: 600, fontSize: 14,
                    cursor: 'pointer', transition: 'all 0.2s',
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </Reveal>

          {SERVICES.map((s, i) => (
            <div key={s.id} style={{ marginBottom: 80 }}>
              <Reveal delay={0.05}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 60,
                  alignItems: 'start',
                  direction: i % 2 === 1 ? 'rtl' : 'ltr',
                }}>
                  {/* Text side */}
                  <div style={{ direction: 'ltr' }}>
                    <div className="tag" style={{ background: s.bg, borderColor: s.border, color: s.color }}>
                      {s.short}
                    </div>
                    <h2 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(24px,3.5vw,38px)', fontWeight: 900, margin: '0 0 16px' }}>{s.title}</h2>
                    <p style={{ color: 'var(--mut)', fontSize: 16, lineHeight: 1.8, marginBottom: 28 }}>{s.desc}</p>

                    {/* Tab-specific bullets */}
                    <div style={{ marginBottom: 28 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--mut)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 14 }}>
                        {activeTab === 'developers' ? 'For Developers & Builders' : 'For Channel Partners & Realtors'}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
                        {(activeTab === 'developers' ? s.forDevelopers : s.forChannelPartners).map((b, j) => (
                          <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{ width: 22, height: 22, background: s.bg, border: `1px solid ${s.border}`, borderRadius: 6, display: 'grid', placeItems: 'center', color: s.color, fontSize: 12, flexShrink: 0 }}>✓</div>
                            <span style={{ fontSize: 15 }}>{b}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    <button
                      onClick={openForm}
                      style={{ padding: '13px 26px', background: s.color, color: '#060912', border: 'none', borderRadius: 10, fontFamily: 'var(--fB)', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}
                    >
                      Get Started →
                    </button>
                  </div>

                  {/* Process card side */}
                  <div style={{ direction: 'ltr', background: s.bg, border: `1px solid ${s.border}`, borderRadius: 20, padding: 40 }}>
                    <div style={{ fontFamily: 'var(--fD)', fontSize: 58, color: s.color, opacity: 0.18, lineHeight: 1, marginBottom: 8 }}>{s.icon}</div>
                    <h3 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 20, marginBottom: 22 }}>Our Process</h3>
                    {['Account audit & competitor research', 'Campaign setup & creative development', 'Launch, monitor & A/B test', 'Weekly optimization & reporting'].map((step, j) => (
                      <div key={j} style={{ display: 'flex', gap: 14, marginBottom: 16, alignItems: 'flex-start' }}>
                        <div style={{ minWidth: 26, height: 26, background: s.color, borderRadius: 7, display: 'grid', placeItems: 'center', color: '#060912', fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 12, flexShrink: 0 }}>{j + 1}</div>
                        <span style={{ color: 'var(--mut)', fontSize: 14, paddingTop: 4 }}>{step}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </Reveal>
            </div>
          ))}

          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <Reveal>
              <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 'clamp(22px,3.5vw,38px)', marginBottom: 16 }}>
                Not sure which service you need?
              </h2>
              <p style={{ color: 'var(--mut)', fontSize: 17, maxWidth: 440, margin: '0 auto 32px' }}>
                Book a free strategy call — we'll map exactly what will move the needle for your business.
              </p>
              <button onClick={openForm} className="btn btn-teal" style={{ fontSize: 16, padding: '15px 30px' }}>
                Book Free Strategy Call →
              </button>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
